export enum ValueUnit {
  Percentage = 'percentage',
  Rating = 'rating',
  Years = 'years',
  Dollars = 'dollars',
  Stars = 'stars',
  MillionsOfDollars = 'millions_of_dollars',
  BasisPoints = 'bps',
  Days = 'days',
  Count = 'count',
}
